import fCore from "foundation-sites/dist/js/plugins/foundation.core.js";
import fMediaQuery from "foundation-sites/dist/js/plugins/foundation.util.mediaQuery.js";
import fInterchange from "foundation-sites/dist/js/plugins/foundation.interchange.js";
// import fReveal 							from 'foundation-sites/dist/js/plugins/foundation.reveal.js';
// import fTimerAndImageLoader from 'foundation-sites/dist/js/plugins/foundation.util.timerAndImageLoader.js';
// import fBox 								from 'foundation-sites/dist/js/plugins/foundation.util.box.js';
// import fTrigger 					  from 'foundation-sites/dist/js/plugins/foundation.util.triggers.js';
// import fKeyboard					  from 'foundation-sites/dist/js/plugins/foundation.util.keyboard.js';
// import fMotion 					    from 'foundation-sites/dist/js/plugins/foundation.util.motion.js';
// import fEqualizer 					from 'foundation-sites/dist/js/plugins/foundation.equalizer.js';

class FoundationInit {
  constructor() {
    this._init();
  }

  _init() {
    document.addEventListener("DOMContentLoaded", event => {
      const $ = jQuery;
      $(document).foundation();

      $(".module-bloc-4vignettes__desc.wysiwyg ul li").each(function() {
        $(this).prepend(
          '<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 141.73 141.73" style="enable-background:new 0 0 141.73 141.73;" xml:space="preserve"><path d="M25.02,74.39c29.16,9.11,61.98-34.63,92.96,0C85.17,54.33,45.07,101.73,25.02,74.39z"/></svg>'
        );
      });
    });
  }
}

export const foundationInit = new FoundationInit();
